(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-test-get-structure', actionTestGetStructure);

    /* - Need a mixture of way we define the rules
     1. by name <- name should not be an actionable name (e.g. redirect, notify, request), instead, should be descriptive: validation-fail, success, failure
     2. by status code
     3. by status code range
     - A Rule should link to an event. When rule is triggered, it will call the next event and pass over all the response from the REST API, or otherwise stated
     - Will go through the list of rules. Rules should be triggered by priority. Once triggered it will break away from the loop.
     - Event name will be prefix by current event name, unless otherwise stated.
     - To make it simpler for the backend (no need to pass over certain rules). Certain status code should be taken care of by the engine. <- discuss with Jag
     Still need to pass me events for these situations.
     - Logic: 422, 400, 500 first, then custom rules, then success rules.
     */

    function actionTestGetStructure($timeout, SodLogger) {
        return (panelId) => {
            SodLogger.debug('Test Get Structure, Panel Id', panelId);
            return $timeout(() => {
                return {
                    events: [
                        {
                            //
                            event: "action-manager.rms.login_form.form_submit",
                            actions: {
                                async : [
                                    {
                                        name: "request",
                                        options: {
                                            endpoint:'/v1/auth/login',
                                            method: 'post'
                                        },
                                        stateMap: {
                                            key: 'model'
                                        }
                                        // stateMutate: {}, // contains info to help mutate the result of the state into what the action required. Not needed to code for now.
                                        // rules: []
                                    }
                                ],
                                sync: []
                            }
                        },

                        {
                            event: "action-manager.rms.login_form.form_submit.request.success",
                            actions: {
                                async: [
                                    {
                                        name: 'notify',
                                        options: {
                                            template: 'Login Successfully' // can do replace here also if needed.
                                        }
                                    }
                                ],
                                sync: []
                            }
                        },

                        {
                            event: "action-manager.rms.login_form.form_submit.error",
                            actions: {
                                async: [],
                                sync: [
                                    {
                                        name: 'mutate-panel-state',
                                        options: [
                                            {
                                                key: 'panel',
                                                data: {

                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        }

                    ],
                    templateUrl: '<fb-form-generator fb-data="vm.panelState.structure.form" fb-model="vm.panelState.model"></fb-form-generator>',
                    form: {
                        "schema": [],
                        "model": {
                            "hid_ref_form": "3476915e3d59ac4bbef03b6e0ec243e1922e",
                            "hid_form_draft_id": "2344194f76f27abc5806fc9cb1476f0b3d6c"
                        },
                        "name": "e369853df766fa44e1ed0ff613f563bd",
                        "form_events": [],
                        "buttons_wrapper_type": "inline",
                        "settings": {
                            "check_for_dirty": false
                        },
                        "elements": [
                            {
                                "label": "Email Address",
                                "type": "email",
                                "name": "txt_email",
                                "attr": [],
                                "position": 1,
                                "options": []
                            },
                            {
                                "label": "Password",
                                "type": "password",
                                "name": "txt_password",
                                "attr": [],
                                "position": 2,
                                "options": []
                            },
                            {
                                "label": "fields.form_draft_id",
                                "type": "hidden",
                                "name": "hid_form_draft_id",
                                "attr": [],
                                "position": 99,
                                "options": []
                            },
                            {
                                "label": "Form ID",
                                "type": "hidden",
                                "name": "hid_ref_form",
                                "attr": [],
                                "position": 99,
                                "options": []
                            }
                        ],
                        "buttons": [
                            {
                                "label": "Login",
                                "type": "submit",
                                "name": "btn_submit",
                                "class": "main expanded rounded",
                                "event": {
                                    "click": "action-manager.rms.login_form.form_submit"
                                },
                                "icon": "",
                                "attr": []
                            }
                        ]
                    }
                };
            }, 1000);
        };
    }
})();